import React from "react";
import "./AmsLanding.scss"
// import { AmsImage } from 'components/image';
import { Button } from 'components/button';
import { AmsAccordion } from "components/accordion"
import { truck, amslogo, clock, nofee, logo } from 'assets/images';
import { faqsData } from './faqs';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { TextField } from "components/textField";
import { Affirm } from '../../screens/affirm';
import { navigate } from "@reach/router";
import moment from "moment";
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { phoneNumberValidator } from "core/utils";
import { createLeadQuery } from "core/services/LeadService"
import { client } from "App";
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import { Popup } from "components/Popup"
import { AffirmTextLandingPage } from "components/affirmTextLandingPage"
import { Header } from "components/header";
import { CardLayout } from "components/cardLayout";
declare var window: any;
export interface AmsLandingProps {
    onClick?(): void;
}

export interface AmsLandingState {
    showAffirm: boolean;
    isValid: boolean;
    open1?: boolean;
    amounts: any;
}


class AmsLanding extends React.Component<AmsLandingProps, AmsLandingState> {
    formGroup: FormGroup = FormBuilder.group(
        {
            name: ['', Validators.required],
            Telephone: ['', phoneNumberValidator],
            letsBegin: ['']
        }

    );
    constructor(props: AmsLandingProps) {
        super(props);
        this.state = {
            showAffirm: false,
            isValid: false,
            open1: false,
            amounts: JSON.parse(localStorage.getItem("amounts") || '{}')
        };
        this.onValueChanges = this.onValueChanges.bind(this);
        this.formGroup.valueChanges.subscribe(this.onValueChanges)
    }
    handleClick() { }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onValueChanges(value: any) {
        if (this.formGroup.valid && !this.state.isValid) {
            this.setState({ isValid: true });
        }
        else if (!this.formGroup.valid && this.state.isValid) {
            this.setState({ isValid: false });
        }
    }
    handleAffirmFlow = () => {
        //  navigate("/affirm")
        localStorage.setItem("isAffirm", "1")
        this.setState({ showAffirm: true });
        navigate("/move?question=paperwork");
    }
    skipFroNow = () => {
        // debugger;
        //    localStorage.setItem("signs",JSON.stringify([
        //     {id:"1", sign:""},
        //     {id:"2", sign:""}
        // ]));

        navigate("/move?question=deposit");
    }
    letsBegin() {
        if (this.props.onClick) {
            this.props.onClick();

        }
        this.setState({ showAffirm: true });
        // this.addLead()
    }
    addLead() {
        //localStorage.removeItem("leadDetails")
        this.createLead()
            .then(response => {
                localStorage.setItem("leadDetails", JSON.stringify(response.data.createLead[0]))
                console.log(response)
                this.setState({ showAffirm: true });
            });

    }


    async createLead() {
        console.clear();
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        console.log(object)
        // for coupon
        var coupon = localStorage.getItem("movewith") === "y" ? "y" : "";
        // for not sure 
        var movingDate = localStorage.getItem("notsure") === "1" ? moment().add(15, "days").format("MM/DD/YY") : moment(object.MoveDate).format("MM/DD/YY")
        var notSure = localStorage.getItem("notsure") === "1" ? "1" : "0"
        var LeadInput = {
            firstName: this.formGroup.value.name + '',
            lastName: "",
            telephone: (this.formGroup.value.Telephone) ? this.formGroup.value.Telephone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "") : "",
            email: "Didnotprovide@allmysons.com",
            moveDate: movingDate,
            moveSize: "1",
            originZip: localStorage.getItem("currentZipCode"),
            src: "pricingpagegoogleapt1br",
            destinationZip: "",
            aPIReferenceID: "1",
            canWeText: "true",
            clientIPAddress: "",
            moveType: object.MoveType,
            promoCode: "",
            unitNo: object.Unit,
            address: object.address,
            movingDateNotSure: notSure
        }
        console.log("LeadInput:" + JSON.stringify(LeadInput));
        return client.query({
            query: createLeadQuery, variables: {
                leadInput: {
                    employeeID: "0",
                    firstName: this.formGroup.value.name + '',
                    lastName: "",
                    telephone: (this.formGroup.value.Telephone) ? this.formGroup.value.Telephone.replace("(", "").replace(")", "-").replace("-", "").replace(" ", "-") : "",
                    email: "Didnotprovide@allmysons.com",
                    moveDate: movingDate,
                    // moveSize:"Apt 1 Bedroom",
                    moveSize: "1",
                    originZip: localStorage.getItem("currentZipCode"),
                    src: "pricingpagegoogleapt1br",
                    destinationZip: "",
                    aPIReferenceID: "1",
                    canWeText: "true",
                    clientIPAddress: "",
                    moveType: object.MoveType,
                    promoCode: "",
                    unitNo: object.Unit,
                    address: object.address,
                    movingDateNotSure: notSure

                }
            }
        });
    }
    componentWillUnmount() {
        this.formGroup.valueChanges.unsubscribe(this.onValueChanges);
    }
    handleOpen1 = () => {
        this.setState({ open1: true });
    };
    onBackPress() {
        navigate('move?question=paperwork');
    }
    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var address = object.address + ", #" + object.Unit
        var weekday = moment(object.MoveDate).format("d")
        var isSuper = parseInt(weekday) <= 3 ? 1 : 0;
        var totalAmt = this.state.amounts.find((item: any) => (item.type === "Month" && item.month === 12))
        var deposit = totalAmt.amount
        console.log(deposit)
        window.affirm.ui.refresh();
        //var deposit = this.state.amounts.find((item:any)=>item.type==="Deposit").amount
        if (this.state.showAffirm === false) {
            return (
                <CardLayout>
                    <div className="landing-container">

                        <Header />

                        {/* Header Image */}
                        <div className="banner-content">
                            <p>As low as</p>
                            <div className="banner-popup">
                                <p><span>${localStorage.getItem("selectedamt")}</span>/mo for {localStorage.getItem("selectedmonth")} months</p>
                                <div className="subheading-popup">
                                    <div className="icon-info affirm-site-modal"></div>
                                </div>
                            </div>
                        </div>

                        {/* Content */}
                        <div className='paylater-content'>
                            {/* <div className='move-now'>
                            <h1>Move Now, Pay Later!</h1>
                        </div> */}
                            <div className="share-logo">
                                <img src={logo} alt="logo" />
                                <p>+</p>
                                <img src={amslogo} alt="amslogo" />
                            </div>
                            <div className="easy-payment">
                                <h2>Make easy payments over 3, 6 or 12 months</h2>
                            </div>
                            {/* <div className="move-cost">
                            <p>For example, a $1000 move might cost $166.67/mo over 6 months at 0% APR.
                                A down payment may be required.</p>
                        </div> */}
                            <div className='payment-info'>
                                <div className="payment-img">
                                    <img src={clock} width='22%' style={{ marginBottom: 5 }} />
                                    <p>Quick and Easy</p>
                                </div>
                                <div className="payment-img">
                                    <img src={nofee} width="28%" style={{ marginBottom: 5 }} />
                                    <p>No hidden fees</p>
                                </div>
                            </div>
                            <div className='check-eligible'>
                                <p>Checking your eligibility won't effect your credit score.</p>
                            </div>
                            {/* <div className="customer-detail">
                            <p>To begin, enter your name, phone number, and current address:</p>
                        </div> */}
                            {/* <div className="affirm-form">
                            <TextField
                                keyboardType={"text"}
                                label={"Name"}
                                formControl={this.formGroup.get('name') as FormControl}
                                variantType={"outlined"}
                            />
                            <TextField
                                label={"Phone"}
                                keyboardType={"tel"}
                                formControl={this.formGroup.get('Telephone') as FormControl}
                                mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                variantType={"outlined"}
                            /> */}
                            {/* <TextField
                                keyboardType={"text"}
                                label={"Main Street"}
                                variantType={"outlined"}
                            /> */}
                            {/* </div> */}
                            {/* <div className="apt-info">
                            <div style={{width: "33vw"}}>
                                <TextField
                                    keyboardType={"text"}
                                    label={"Apt#"}
                                    variantType={"outlined"}
                                />

                            </div>
                            <div className="zipcode-field">
                                <TextField
                                    keyboardType={"text"}
                                    label={"ZipCode"}
                                    variantType={"outlined"}
                                />
                            </div>
                            <div style={{width: "19vw"}}>
                            <TextField
                                keyboardType={"text"}
                                label={"TX"}
                                variantType={"outlined"}
                            />
                            </div>
                        </div> */}
                            <div className="btn-container">
                                <Button text="Let's Begin"
                                    backgroundColor={"#4E9CE6"}
                                    color={"#ffffff"}
                                    formControl={this.formGroup.get('letsBegin') as FormControl}
                                    //formGroup={this.formGroup}
                                    onClick={() => this.letsBegin()}
                                />
                                <Button text="Skip For Now"
                                    backgroundColor={"#ffffff"}
                                    marginTop={"0em"}
                                    border={"3px solid #4E9CE6"}
                                    color={"#4E9CE6"}
                                    style={{}}
                                    onClick={() => this.skipFroNow()}
                                />

                            </div>

                            {/* FAQs */}
                            <div className='faqs-container'>
                                <h2 className='faqs-heading'>FAQs</h2>
                                <AmsAccordion expanded={false} data={faqsData}></AmsAccordion>
                                <div className='help-text'>
                                    <p>See more info in the <a href="https://www.affirm.com/help/" target="_blank" rel="noopener noreferrer">Help Center</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </CardLayout>
            );
        } else {
            return <Affirm />
        }
    }
}

export default AmsLanding;